import Vue from 'vue'
import axios from 'axios'

const SC_API = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_SC_URL : '/api/v2',
  headers: {
    'Content-Type': 'application/json'
  },
  auth: {
    username: process.env.VUE_APP_SC_USER,
    password: process.env.VUE_APP_SC_PASS,
  }
})

export default Vue.prototype.$sendcloud = SC_API;